import { type ComponentType, createElement } from "react";
import { StyledTd, StyledTr } from "src/styled";

export type TRenderScrollableRow<T> =
  | Array<keyof T | { value: keyof T; tdProps?: Record<string, any> }>
  | ComponentType<{ row: T; index?: number }>;

interface Props<T> {
  row: T;
  render: TRenderScrollableRow<T>;
  index?: number;
}
const ScrollableTableRow = <T extends Record<string, any>>({
  row,
  render,
  index,
}: Props<T>) => {
  if (!row || !render) return <></>;
  if (Array.isArray(render))
    return (
      <StyledTr>
        {render.map(key => {
          if (typeof key === "object" && "value" in key) {
            return (
              <StyledTd key={key.value as string} {...key.tdProps}>
                {Array.isArray(row[key.value])
                  ? row[key.value].join(", ")
                  : row[key.value]}
              </StyledTd>
            );
          }
          return (
            <StyledTd key={key as string}>
              {Array.isArray(row[key]) ? row[key].join(", ") : row[key]}
            </StyledTd>
          );
        })}
      </StyledTr>
    );

  return createElement(render, {
    row,
    index,
  });
};

export default ScrollableTableRow;
